import { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { AnimatePresence, motion } from "framer-motion";
import { ReactComponent as StrmPlans } from "shared/assets/images/strm-plans.svg";
import { CloseOutlined } from "@ant-design/icons";
import modalImageSuccess from "shared/assets/images/subscription-result-modal-success-bg.png";
import modalImageError from "shared/assets/images/subscription-result-modal-error-bg.jpg";
import { useLocation } from "react-router-dom";
import { ReactComponent as AdiantamentosIcon } from "shared/assets/images/icon-wallet.svg";
import { ReactComponent as QuincyIcon } from "shared/assets/images/quincy-icon.svg";
import { ReactComponent as DiagnosticoIcon } from "shared/assets/images/icon-diagnostic.svg";
import { ReactComponent as StrmClassIcon } from "shared/assets/images/icon-strm-class.svg";
import { ReactComponent as RecomendacaoIcon } from "shared/assets/images/icon-recomendacao.svg";
import { ReactComponent as MetasIcon } from "shared/assets/images/icon-metas.svg";
import { ReactComponent as PromotionIcon } from "shared/assets/images/icon-promotion.svg";

const icons = [
  <DiagnosticoIcon stroke="#CECDFF" />,
  <AdiantamentosIcon stroke="#CECDFF" />,
  <QuincyIcon fill="#CECDFF" />,
  <RecomendacaoIcon stroke="#CECDFF" fill="#CECDFF" />,
  <StrmClassIcon stroke="#CECDFF" />,
  <MetasIcon stroke="#CECDFF" />,
  <PromotionIcon stroke="#CECDFF" />,
];

interface ModalProps {
  // isOpen: boolean;
  // setIsOpen: Dispatch<SetStateAction<boolean>>;
  // type?: "success" | "failed";
}

const ModalSignatureComplete: React.FC<ModalProps> = (props) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const premiumResult = searchParams.get("premium");
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const { t } = useTranslation();
  const { success, error }: any = t("pages.Pricing.modal.results");

  const textByType = !premiumResult
    ? {}
    : premiumResult === "success"
    ? success
    : error;

  useEffect(() => {
    if (premiumResult) {
      setIsOpen(true);
    }
  }, [premiumResult]);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={() => setIsOpen(false)}
          className="modal-signature-overlay"
        >
          <motion.div
            initial={{ scale: 0, rotate: "12.5deg" }}
            animate={{ scale: 1, rotate: "0deg" }}
            exit={{ scale: 0, rotate: "0deg" }}
            onClick={(e) => e.stopPropagation()}
            className="modal-content"
          >
            <div>
              <img
                src={
                  premiumResult === "success"
                    ? modalImageSuccess
                    : modalImageError
                }
                alt="pricing"
                style={{ borderRadius: "0.5rem 0.5rem 0 0" }}
                className="responsive-pricing-image"
              />
              <div className="modal-content-image">
                <span className="flex-plan">
                  <StrmPlans />
                  {textByType.title}
                </span>
                <span className="flex-subtitle">{textByType.subtitle}</span>
                <CloseOutlined
                  onClick={() => setIsOpen(false)}
                  className="close-icon"
                />
              </div>
              <div className="modal-content-text">
                <div>
                  <Trans
                    i18nKey={textByType.description}
                    components={{ span: <span className="green-color" /> }}
                  />
                </div>
                <div
                  style={{
                    margin: "24px 0",
                    display: "flex",
                    flexDirection: "column",
                    gap: 16,
                  }}
                >
                  {premiumResult === "success" ? (
                    textByType.content.map((item: string, index: number) => (
                      <div key={index} className="row-content">
                        {icons[index]}
                        <span className="body-large">{item}</span>
                      </div>
                    ))
                  ) : (
                    <span className="body-large">{textByType.content}</span>
                  )}
                </div>
                <span className="botao-branco" onClick={() => setIsOpen(false)}>
                  {textByType.buttonText}
                </span>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ModalSignatureComplete;
